<template>
  <div class="vl-main">
    <!--头部-->
    <div is="vlHeader"></div>
    <!--内容区-->
    <div class="vl-content">
      <router-view></router-view>
    </div>
    <!--底部-->
    <div is="vlFooter"></div>
    <div is="imgZoom"></div>
  </div>
</template>
<script>
  import imgZoom from '@/components/common/imgZoom.vue';
  import vlHeader from '@/components/header.vue';
  import vlFooter from '@/components/footer.vue';
  export default {
    components: { imgZoom, vlHeader, vlFooter },
    data() {
      return {

      }
    },
    mounted() {
      // 判断当前是否有需要重载的路由,前提是当前路由是home
      let hisRoute = window.sessionStorage.getItem('hisHash');
      if (hisRoute && hisRoute !== 'home' && this.$route.name === 'home') {
        console.log('路由重载');
        let hisParam = JSON.parse(window.sessionStorage.getItem('hisHashParam'));
        this.$router.push({
          name: hisRoute,
          query: hisParam
        })
        window.sessionStorage.removeItem('hisHash');
        window.sessionStorage.removeItem('hisHashParam');
      }

    },
    methods: {

    },
  }
</script>
<style lang="scss" scoped>
  .vl-main {
    width: 100%;
    height: 100%;
    @include setColor('background-color', 'chunk_3');
  }
  .vl-content {
    margin-top: 70px;
    padding-top: 1px;
    min-height: calc( 100% - 313px);
    @include setColor('background-color', 'chunk_3');
  }
</style>